// import config from "gia/config";

/////////////////// Imports ////////////////////
////////////////////////////////////////////////

// Libs. //
import config from "gia/config";

// Modules //
import initPageTransitions from "./modules/PageTransitions.js";
import initMobileMenu from "./modules/MobileMenu.js";
// import ScrollTracker from "./modules/ScrollTracker.js";
// import ScrollTriggers from "./modules/ScrollTriggers.js";
// import ScrollProgressNodes from "./modules/ScrollProgressNodes.js";

// Components //
import WorkStream from "../site/snippets/work-stream/js/work-stream.js";
import ProjectViewerV2 from "../site/snippets/project-viewer-v2/js/project-viewer-v2.js";
import StaffImages from "../site/snippets/staff-images/js/staff-images.js";
import ProcessSteps from "../site/snippets/process-steps/js/process-steps.js";
import Contact from "../site/snippets/contact/js/contact.js";

const comps = {
  Contact,
  ProcessSteps,
  ProjectViewerV2,
  StaffImages,
  WorkStream,
};

//////////////////// Utils. ////////////////////
////////////////////////////////////////////////

const initBottomMenuGridAlignment = () => {
  const menu = document.querySelector('[data-nav-menu-bottom]');
  if (!menu) return;

  const syncPosition = () => {
    const unitSpacing = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--unit-spacing')) || 30;
    const gridBottom = Math.floor(window.innerHeight / unitSpacing) * unitSpacing;
    menu.style.top = `${gridBottom}px`;
  };

  syncPosition();
  window.addEventListener('resize', syncPosition, { passive: true });
};

//////////////////// Assets ////////////////////
////////////////////////////////////////////////

import consoleStyles from "./assets/consoleStyles.js";

//////////////////// Init. /////////////////////
////////////////////////////////////////////////

config.set("log", false);

///// Post DOM-content-loaded //////
////////////////////////////////////

document.addEventListener("DOMContentLoaded", () => {
  console.log("%cDOM content loaded...", consoleStyles.default);

  // console.log("%cLoading modules...", consoleStyles.default); // NOT NEEDED ATM
  // new ScrollTracker({ log: false });
  // new ScrollTriggers({ log: true });
  // new ScrollProgressNodes({ log: true });

  console.log("%cInitializing page transitions...", consoleStyles.default);
  initPageTransitions(comps);

  initMobileMenu();
  initBottomMenuGridAlignment();

  console.log("%cApp initialized!", consoleStyles.success);
});
